import { Box, Typography } from "@mui/material"
import { NoDataFound } from "../../../../empty/Index"
import moment from "moment"

export const Tbody = ({salesProductList, generateForm}) => {

    return (
            <Box
                height="100%"
                overflowY="auto"
                width="100%"
                bgcolor="#FFFFFF"
                borderRadius="12px"
                className="overflowY"
                display="flex"
                flexDirection="column"
                gap="12px"
                p={2}
            >
            {(!generateForm.infiniteLoad && salesProductList.length === 0) && (
                <Box sx={{height: "100%"}}>
                    <NoDataFound />
                </Box>
            )}

            {(!generateForm.infiniteLoad && salesProductList.length > 0) &&
                salesProductList.map((v, k) => (
                <Box
                    key={k}
                    sx={{
                    p: 2,
                    borderRadius: "12px",
                    boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                    border: 1,
                    borderColor: "#c9c9c9ff"
                    }}
                >
                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box fontSize={12}>Branch:</Box>
                            <Typography fontSize={13} fontWeight={500}>{v.branch_name}</Typography>
                        </Box>

                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box fontSize={12}>Product:</Box>
                            <Typography fontSize={13} fontWeight={500}>
                            {v.alias === null || v.alias.trim() === "" ? `${v.sub_cat_name} ${v.product_name}` : v.alias}
                            </Typography>
                        </Box>

                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box fontSize={12}>Date:</Box>
                            <Typography fontSize={13}>
                            {moment(v.created_at).format("YYYY-MM-DD h:mm a")}
                            </Typography>
                        </Box>

                        {/* Quantity */}
                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box fontSize={12}>Quantity:</Box>
                            <Typography fontSize={13} fontWeight={500}>
                            {parseFloat(v.quantity).toLocaleString("en-PH")}
                            </Typography>
                        </Box>

                        {/* Amount */}
                        <Box sx={{display: "flex", justifyContent: "space-between"}}>
                            <Box fontSize={12}>Amount:</Box>
                            <Typography fontSize={13} fontWeight={600} color="primary.main">
                            ₱{" "}
                            {parseFloat(v.amount).toLocaleString("en-PH", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}
                            </Typography>
                        </Box>

                </Box>
                ))}
            </Box>
    )
}